import React, { useState, useEffect } from "react";
import { MainAdminNewsCategoryTable, UploadNewsSideInput } from "../../components"
import { Outlet } from "react-router-dom"
import Text from "../../assets/icon/NewsIcons/MainAdmin/NewsText"
import Group from "../../assets/icon/NewsIcons/MainAdmin/NewsGroup"
import Search from "../../assets/icon/NewsIcons/MainAdmin/NewsSearch"
import Report from "../../assets/icon/NewsIcons/MainAdmin/NewsReport"
import { axiosReq } from "../../commons/axiosReq";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import Cookies from 'universal-cookie';

const MainAdminUploadNews = () => {
    const [data, setData] = useState();
    const [accept, setAccept] = useState(false);
    const [cats, setCats] = useState([]);
    const [text, setText] = useState();
    const [tags, setTags] = useState();
    const [searchTag, setSearchTag] = useState("");
    const [reCheck, setRecheck] = useState();
    let navigate = useNavigate();
    const [video, setVideo] = useState();
    const [image, setImage] = useState([]);

    const location = useLocation();

    const GetData = async () => {
        if (location?.state?.id) {
            const articleData = await axiosReq("Admins/GetArticlebySlug?slug=" + location?.state?.id, "get");
            console.log(articleData)
            setData(articleData)
        }
        const cookies = new Cookies();
        console.log(555) 
        console.log(cookies.get('role'))
        const catsData = await axiosReq(cookies.get('role')=="Admin"?"Admins/GetCategories":"Admins/GetCategoryByAuthorId", "get");
        // const catsData = await axiosReq("Admins/GetCategories", "get");
        console.log(catsData)

        var catArr = [];
        catsData?.data?.map((item) => {
            catArr.push({ value: item.categoryId, label: item.categoryName })
        })
        setCats(catArr)


    }
    const auth = async () => {
        const cookies = new Cookies();
        var token = cookies.get('token');
        console.log(token)
        console.log(cookies.get('role'))
        if (!token) {
            navigate("/admin");
        } else {

            GetData()

        }
    }
    const GetTags = async () => {
        const tagsData = await axiosReq("Admins/GetTags?search=" + searchTag, "get");
        console.log(1234)
        console.log(tagsData)

        var tagArr = [];
        tagsData?.data?.map((item) => {
            tagArr.push({ value: item.tagId, label: item.tag })
        })
        setTags(tagArr)
    }
    useEffect(() => {
 console.log("0000")

        auth();
        
    }, []);

    useEffect(() => {
        GetTags();
    }, [reCheck, searchTag]);
    //     useEffect(() => {
    // alert(text)
    //     }, [text]);


    return (
        <div>
            <div className="flex items-center border-b-2 border-borderGray p-[20px]">
                <div className="flex items-center">
                    <div><Text /></div>
                    <p className="font-IRANYekanExtra text-mainColor2 text-[15px] mr-[15px]">بارگزاری خبر جدید</p>
                </div>
            </div>
            <div className="pt-[20px] px-[20px] pb-[280px] w-full flex">
                <div className="w-[29%] ml-[1%]"><UploadNewsSideInput cats={cats} text={text} video={video}
                    tags={tags} reCheck={reCheck} setRecheck={setRecheck} setSearchTag={setSearchTag} image={image} /></div>
                <div className="w-[70%]"><Outlet context={[setText, text,accept,data,video,setVideo,image,setImage]} /></div>
            </div>
        </div>
    )
}

export default MainAdminUploadNews;